export default "__VITE_ASSET__8jVjECZE__"